import { render } from "./CanNotAccess.vue?vue&type=template&id=72b3971b&scoped=true"
import script from "./CanNotAccess.vue?vue&type=script&lang=js"
export * from "./CanNotAccess.vue?vue&type=script&lang=js"

import "./CanNotAccess.vue?vue&type=style&index=0&id=72b3971b&scoped=true&lang=css"

import exportComponent from "F:\\code\\my_business\\giaiphapmmo_business_2023\\front_end\\company_for_tax\\admin_site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72b3971b"]])

export default __exports__